/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Feedback_TipInputs */



/**
* | output |
* | --- |
* | "Tip to take with you" |
*
* @param {Practice_Feedback_TipInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_feedback_tip = /** @type {((inputs?: Practice_Feedback_TipInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Feedback_TipInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Tip om mee te nemen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conseil à retenir")
	return /** @type {LocalizedString} */ ("Tip to take with you")
});